$(function() {
  $(".js-header__burger").on("click", function openMobileMenu() {
    $(".js-header").toggleClass("is-open");
  });

  $(".js-header__search").on("click", function openMobileSearch() {
    $(".js-header__search_close, .js-header-form__field").toggleClass(
      "is-open"
    );
  });

  $(".js-header-form__field").on("input", showClearButton);

  $(document).on("click", ".js-clear-search", function() {
    $(this)
      .siblings(".js-header-form__field")
      .val("");
    $(this).removeClass("is-show");
  });

  $(".js-header-cities__btn").on("click", function openCitiesList() {
    const $menu = $(this).siblings(".js-header-cities__list");

    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");

      return $($menu).removeClass("is-open");
    }

    $(".js-header-cities__btn, .js-header-cities__list").removeClass("is-open");

    $(this).addClass("is-open");
    $($menu).addClass("is-open");
  });

  $(".js-header-cities__link").on("click", function setLocation(e) {
    e.preventDefault();
    let url = $(this).data("href");

    $.ajax({
      method: "post",
      url: url,
      contentType: "application/json",
      data: {}
    })
      .done(response => {
        window.location = response;
      })
      .fail((e, rr, ors) => {
        window.location.reload(true);
      });
  });

  $(document).click(function closeBlocks(e) {
    const headerCheck = $(e.target).closest(".js-header").length;
    const citiesCheck = $(e.target).closest(".js-header-cities__list").length;
    const citiesBtnCheck = $(e.target).closest(".js-header-cities__btn").length;

    if (!headerCheck) {
      $(".js-header").removeClass("is-open");
    }

    if (!citiesCheck && !citiesBtnCheck) {
      $(".js-header-cities__btn, .js-header-cities__list").removeClass(
        "is-open"
      );
    }
  });
});

function showClearButton(e) {
  const clearBtn = $(e.target).siblings(".js-clear-search");

  if ($(e.target).val() === "") return clearBtn.removeClass("is-show");

  if (clearBtn.hasClass("is-show")) return;

  clearBtn.addClass("is-show");
}

$(function() {
  var isMobile = false, $window = $(window);
  
  var moveGoogleTranslateElement = function() {
      if ($window.width() < 768 && isMobile == false) {
          isMobile = true;
          $('#google-translate-element').detach().appendTo('#google-translate-container-mobile');                            
      } else if ($window.width() >= 768 && isMobile == true) {
          isMobile = false;
          $('#google-translate-element').detach().appendTo('#google-translate-container-desktop');                            
      }
  };

  $window.on('resize', moveGoogleTranslateElement);
  moveGoogleTranslateElement();
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/header.js